export const sortTimelineSubblocks = (subblocks = []) => {
  return [...subblocks].sort((a, b) => {
    const aDate = a?.card_date ? new Date(a.card_date) : null;
    const bDate = b?.card_date ? new Date(b.card_date) : null;

    const aTime = aDate ? aDate.getTime() : null;
    const bTime = bDate ? bDate.getTime() : null;

    if (aTime === null && bTime === null) return 0;
    if (aTime === null) return -1;
    if (bTime === null) return 1;
    return aTime - bTime;
  });
};
